import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Grid,
  GridItem,
  Card,
  CardBody,
  Icon,
  VStack,
  HStack,
  useColorModeValue,
  Button
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { MdGroupWork, MdDashboard, MdInfo } from 'react-icons/md';

const AssociadoDashboard = () => {
  const navigate = useNavigate();
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const textColor = useColorModeValue('gray.600', 'gray.300');
  const headingColor = useColorModeValue('gray.800', 'white');
  
  return (
    <Container maxW="container.xl" py={8}>
      <VStack spacing={8} align="stretch">
        {/* Header */}
        <Box>
          <Heading size="lg" mb={2} color={headingColor}>
            Bem-vindo, {userInfo?.name || 'Associado'}!
          </Heading>
          <Text color={textColor}>
            Área do Associado - MICA CAPITAL
          </Text>
        </Box>

        {/* Quick Stats */}
        <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)' }} gap={6}>
          <GridItem>
            <Card bg={bgColor} borderWidth="1px" borderColor={borderColor}>
              <CardBody>
                <HStack spacing={4}>
                  <Icon as={MdDashboard} boxSize={10} color="green.500" />
                  <VStack align="start" spacing={0}>
                    <Text fontSize="sm" color={textColor}>
                      Status
                    </Text>
                    <Text fontSize="xl" fontWeight="bold" color={headingColor}>
                      Ativo
                    </Text>
                  </VStack>
                </HStack>
              </CardBody>
            </Card>
          </GridItem>

          <GridItem>
            <Card bg={bgColor} borderWidth="1px" borderColor={borderColor}>
              <CardBody>
                <HStack spacing={4}>
                  <Icon as={MdGroupWork} boxSize={10} color="purple.500" />
                  <VStack align="start" spacing={0}>
                    <Text fontSize="sm" color={textColor}>
                      Acesso a
                    </Text>
                    <Text fontSize="xl" fontWeight="bold" color={headingColor}>
                      Grupos
                    </Text>
                  </VStack>
                </HStack>
              </CardBody>
            </Card>
          </GridItem>

          <GridItem>
            <Card bg={bgColor} borderWidth="1px" borderColor={borderColor}>
              <CardBody>
                <HStack spacing={4}>
                  <Icon as={MdInfo} boxSize={10} color="blue.500" />
                  <VStack align="start" spacing={0}>
                    <Text fontSize="sm" color={textColor}>
                      Perfil
                    </Text>
                    <Text fontSize="xl" fontWeight="bold" color={headingColor}>
                      Associado
                    </Text>
                  </VStack>
                </HStack>
              </CardBody>
            </Card>
          </GridItem>
        </Grid>

        {/* Actions */}
        <Box>
          <Heading size="md" mb={4} color={headingColor}>
            Ações Rápidas
          </Heading>
          <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }} gap={6}>
            <GridItem>
              <Card 
                bg={bgColor} 
                borderWidth="1px" 
                borderColor={borderColor}
                cursor="pointer"
                _hover={{ shadow: 'lg', transform: 'translateY(-2px)' }}
                transition="all 0.2s"
                onClick={() => navigate('/associado/precatorio-groups')}
              >
                <CardBody>
                  <VStack spacing={4} align="start">
                    <Icon as={MdGroupWork} boxSize={8} color="purple.500" />
                    <Box>
                      <Heading size="sm" mb={2} color={headingColor}>
                        Agrupamento de Precatórios
                      </Heading>
                      <Text fontSize="sm" color={textColor}>
                        Visualize precatórios agrupados por CPF, CNPJ ou OAB para cada estado
                      </Text>
                    </Box>
                    <Button 
                      colorScheme="purple" 
                      size="sm"
                      rightIcon={<Icon as={MdGroupWork} />}
                    >
                      Acessar Grupos
                    </Button>
                  </VStack>
                </CardBody>
              </Card>
            </GridItem>

            <GridItem>
              <Card 
                bg={bgColor} 
                borderWidth="1px" 
                borderColor={borderColor}
                opacity={0.7}
              >
                <CardBody>
                  <VStack spacing={4} align="start">
                    <Icon as={MdInfo} boxSize={8} color="gray.400" />
                    <Box>
                      <Heading size="sm" mb={2} color={headingColor}>
                        Mais funcionalidades
                      </Heading>
                      <Text fontSize="sm" color={textColor}>
                        Novas funcionalidades serão adicionadas em breve
                      </Text>
                    </Box>
                    <Button 
                      size="sm"
                      isDisabled
                      variant="outline"
                    >
                      Em breve
                    </Button>
                  </VStack>
                </CardBody>
              </Card>
            </GridItem>
          </Grid>
        </Box>

        {/* Info Section */}
        <Card bg={bgColor} borderWidth="1px" borderColor={borderColor}>
          <CardBody>
            <Heading size="sm" mb={3} color={headingColor}>
              Sobre o Acesso de Associado
            </Heading>
            <Text fontSize="sm" color={textColor} mb={3}>
              Como associado, você tem acesso ao módulo de Agrupamento de Precatórios, onde pode visualizar 
              informações consolidadas sobre precatórios organizados por CPF, CNPJ ou OAB.
            </Text>
            <Text fontSize="sm" color={textColor}>
              Este acesso permite uma visão completa dos agrupamentos, facilitando a análise e 
              acompanhamento dos precatórios de forma organizada e eficiente.
            </Text>
          </CardBody>
        </Card>
      </VStack>
    </Container>
  );
};

export default AssociadoDashboard;